import { useEffect, useState } from 'react';
import arrow from '../../../../assets/media/icons/open_icon.svg';
import arrow_white from '../../../../assets/media/icons/open_icon_white.svg';
import styles from './styles.module.scss';

import cn from 'classnames';

const AnimateArrow = ({ isOpen = false, grey = false, onClick = () => {}, is_white = false, ...props }) => {
  const [open, changeOpen] = useState(isOpen);

  useEffect(() => {
    changeOpen(isOpen);
  }, [isOpen]);

  const clickOpen = () => {
    changeOpen(!open);
    onClick();
  };

  return (
    <div className={styles.arrow_block} onClick={() => clickOpen()}>
      <img
        src={is_white ? arrow_white : arrow}
        alt="open"
        style={props.style}
        className={cn(open ? styles.open_icon_rotate : styles.open_icon, props.styles)}
      />
    </div>
  );
};

export default AnimateArrow;
